import { mergeQueryKeys } from '@lukemorales/query-key-factory';

import { versionKeys } from './versionKeys';

export const keys = mergeQueryKeys(versionKeys);
